/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Serializer for Celery task information.
 * @export
 * @interface CeleryTask
 */
export interface CeleryTask {
  /**
   *
   * @type {string}
   * @memberof CeleryTask
   */
  worker: string;
  /**
   *
   * @type {string}
   * @memberof CeleryTask
   */
  taskId: string;
  /**
   *
   * @type {string}
   * @memberof CeleryTask
   */
  taskName: string;
  /**
   *
   * @type {string}
   * @memberof CeleryTask
   */
  args?: string;
  /**
   *
   * @type {number}
   * @memberof CeleryTask
   */
  startedAt?: number | null;
  /**
   *
   * @type {string}
   * @memberof CeleryTask
   */
  eta?: string | null;
}

/**
 * Check if a given object implements the CeleryTask interface.
 */
export function instanceOfCeleryTask(value: object): value is CeleryTask {
  if (!('worker' in value) || value['worker'] === undefined) return false;
  if (!('taskId' in value) || value['taskId'] === undefined) return false;
  if (!('taskName' in value) || value['taskName'] === undefined) return false;
  return true;
}

export function CeleryTaskFromJSON(json: any): CeleryTask {
  return CeleryTaskFromJSONTyped(json, false);
}

export function CeleryTaskFromJSONTyped(json: any, ignoreDiscriminator: boolean): CeleryTask {
  if (json == null) {
    return json;
  }
  return {
    worker: json['worker'],
    taskId: json['task_id'],
    taskName: json['task_name'],
    args: json['args'] == null ? undefined : json['args'],
    startedAt: json['started_at'] == null ? undefined : json['started_at'],
    eta: json['eta'] == null ? undefined : json['eta'],
  };
}

export function CeleryTaskToJSON(value?: CeleryTask | null): any {
  if (value == null) {
    return value;
  }
  return {
    worker: value['worker'],
    task_id: value['taskId'],
    task_name: value['taskName'],
    args: value['args'],
    started_at: value['startedAt'],
    eta: value['eta'],
  };
}
